module.exports = __webpack_public_path__ + "img/bg_1.2fc89590.jpg";